/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * SingleStore API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { computed, unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  ApiResponseSingleStoreSessionKillExecuteRS,
  ApiResponseSingleStoreShowCreateExecuteRS,
  ApiResponseSqlPlanRs,
  ApiResponseString,
  GetDbSinglestoreFullTextByInstanceIdParams,
  GetDbSinglestoreShowCreateByInstanceIdParams,
  SingleStoreSessionKillRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary [SingleStore] SQL Full Text
 */
export const getDbSinglestoreFullTextByInstanceId = (
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetDbSinglestoreFullTextByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseString>(
    {
      url: `/api/db/singlestore/${instanceId}/full-text`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetDbSinglestoreFullTextByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetDbSinglestoreFullTextByInstanceIdParams>,
) => {
  return [
    'api',
    'db',
    'singlestore',
    instanceId,
    'full-text',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDbSinglestoreFullTextByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetDbSinglestoreFullTextByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetDbSinglestoreFullTextByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>
  > = ({ signal }) =>
    getDbSinglestoreFullTextByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>,
    TError,
    TData
  >;
};

export type GetDbSinglestoreFullTextByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>
>;
export type GetDbSinglestoreFullTextByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [SingleStore] SQL Full Text
 */

export function useGetDbSinglestoreFullTextByInstanceId<
  TData = Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params?: MaybeRef<GetDbSinglestoreFullTextByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestoreFullTextByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDbSinglestoreFullTextByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [SingleStore] Kill Session
 */
export const postDbSinglestoreKillSessionByInstanceId = (
  instanceId: MaybeRef<string>,
  singleStoreSessionKillRequest: MaybeRef<SingleStoreSessionKillRequest[]>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  singleStoreSessionKillRequest = unref(singleStoreSessionKillRequest);

  return customAxiosInstance<ApiResponseSingleStoreSessionKillExecuteRS>(
    {
      url: `/api/db/singlestore/${instanceId}/kill-session`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: singleStoreSessionKillRequest,
      signal,
    },
    options,
  );
};

export const getPostDbSinglestoreKillSessionByInstanceIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>,
    TError,
    { instanceId: string; data: BodyType<SingleStoreSessionKillRequest[]> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SingleStoreSessionKillRequest[]> },
  TContext
> => {
  const mutationKey = ['postDbSinglestoreKillSessionByInstanceId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>,
    { instanceId: string; data: BodyType<SingleStoreSessionKillRequest[]> }
  > = (props) => {
    const { instanceId, data } = props ?? {};

    return postDbSinglestoreKillSessionByInstanceId(instanceId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostDbSinglestoreKillSessionByInstanceIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>
>;
export type PostDbSinglestoreKillSessionByInstanceIdMutationBody = BodyType<
  SingleStoreSessionKillRequest[]
>;
export type PostDbSinglestoreKillSessionByInstanceIdMutationError = ErrorType<unknown>;

/**
 * @summary [SingleStore] Kill Session
 */
export const usePostDbSinglestoreKillSessionByInstanceId = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>,
      TError,
      { instanceId: string; data: BodyType<SingleStoreSessionKillRequest[]> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postDbSinglestoreKillSessionByInstanceId>>,
  TError,
  { instanceId: string; data: BodyType<SingleStoreSessionKillRequest[]> },
  TContext
> => {
  const mutationOptions = getPostDbSinglestoreKillSessionByInstanceIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary [SingleStore] Sql Plan
 */
export const getDbSinglestorePlanByInstanceIdAndPlanId = (
  instanceId: MaybeRef<string>,
  planId: MaybeRef<number>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  planId = unref(planId);

  return customAxiosInstance<ApiResponseSqlPlanRs>(
    { url: `/api/db/singlestore/${instanceId}/plan/${planId}`, method: 'GET', signal },
    options,
  );
};

export const getGetDbSinglestorePlanByInstanceIdAndPlanIdQueryKey = (
  instanceId?: MaybeRef<string>,
  planId?: MaybeRef<number>,
) => {
  return ['api', 'db', 'singlestore', instanceId, 'plan', planId] as const;
};

export const getGetDbSinglestorePlanByInstanceIdAndPlanIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  planId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetDbSinglestorePlanByInstanceIdAndPlanIdQueryKey(instanceId, planId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>
  > = ({ signal }) =>
    getDbSinglestorePlanByInstanceIdAndPlanId(instanceId, planId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!(unref(instanceId) && unref(planId))),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>,
    TError,
    TData
  >;
};

export type GetDbSinglestorePlanByInstanceIdAndPlanIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>
>;
export type GetDbSinglestorePlanByInstanceIdAndPlanIdQueryError = ErrorType<unknown>;

/**
 * @summary [SingleStore] Sql Plan
 */

export function useGetDbSinglestorePlanByInstanceIdAndPlanId<
  TData = Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  planId: MaybeRef<number>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestorePlanByInstanceIdAndPlanId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDbSinglestorePlanByInstanceIdAndPlanIdQueryOptions(
    instanceId,
    planId,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary [SingleStore] Show Create
 */
export const getDbSinglestoreShowCreateByInstanceId = (
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetDbSinglestoreShowCreateByInstanceIdParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  instanceId = unref(instanceId);
  params = unref(params);

  return customAxiosInstance<ApiResponseSingleStoreShowCreateExecuteRS>(
    {
      url: `/api/db/singlestore/${instanceId}/show-create`,
      method: 'GET',
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getGetDbSinglestoreShowCreateByInstanceIdQueryKey = (
  instanceId?: MaybeRef<string>,
  params?: MaybeRef<GetDbSinglestoreShowCreateByInstanceIdParams>,
) => {
  return [
    'api',
    'db',
    'singlestore',
    instanceId,
    'show-create',
    ...(params ? [params] : []),
  ] as const;
};

export const getGetDbSinglestoreShowCreateByInstanceIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetDbSinglestoreShowCreateByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetDbSinglestoreShowCreateByInstanceIdQueryKey(instanceId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>
  > = ({ signal }) =>
    getDbSinglestoreShowCreateByInstanceId(instanceId, params, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: computed(() => !!unref(instanceId)),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>,
    TError,
    TData
  >;
};

export type GetDbSinglestoreShowCreateByInstanceIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>
>;
export type GetDbSinglestoreShowCreateByInstanceIdQueryError = ErrorType<unknown>;

/**
 * @summary [SingleStore] Show Create
 */

export function useGetDbSinglestoreShowCreateByInstanceId<
  TData = Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>,
  TError = ErrorType<unknown>,
>(
  instanceId: MaybeRef<string>,
  params: MaybeRef<GetDbSinglestoreShowCreateByInstanceIdParams>,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDbSinglestoreShowCreateByInstanceId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetDbSinglestoreShowCreateByInstanceIdQueryOptions(
    instanceId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}
